var $ = jQuery;
var siteUrl = WPURLS.siteurl;
var smallLogo = '/assets/img/stiddard_logo_small.png';
var bigLogo = '/assets/img/stiddard_logo_large2.png';

$(document).on("scroll", function(){
  if ($(document).scrollTop() > 10)
  {
    $(".brand-image").attr('src', siteUrl + smallLogo);
    $(".block-header-poly-wrapper").addClass("header-height-min");
  }
  else
  {
    $(".brand-image").attr('src', siteUrl + bigLogo);
    $(".block-header-poly-wrapper").removeClass("header-height-min");
  }
});
